@if (currentShadeToolType!==ShadeToolType.Empty) {
  <div class="shade-host">
    <div class="shade-bkgd">

      @if (currentShadeToolType===ShadeToolType.SHADE_DIALOG_BOX) {
        <motn-dialog-box
          [header]=props.header
          [message]=props.message
          [messageHtml]=props.messageHtml
          [options]=props.dialogOptions
          [enableInput]=props.enableInput
          [passwordInput]=props.password
          [closeOnButtonClick]=props.closeOnButtonClick
        ></motn-dialog-box>
      }
      @if (currentShadeToolType===ShadeToolType.SHADE_USER_SHARING_DIALOG_BOX) {
        <user-sharing-dialog-box
          [object]="userSharingDialogProps.object"
          (close)="onUserSharingDialogClose()"
        ></user-sharing-dialog-box>
      }
    </div>
  </div>
}
